"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RibbonButton_1 = require("./schema/RibbonButton");
exports.RibbonButtonState = RibbonButton_1.RibbonButtonState;
var Ribbon_1 = require("./components/Ribbon");
exports.Ribbon = Ribbon_1.default;
var RibbonPlugin_1 = require("./plugins/RibbonPlugin");
exports.RibbonPlugin = RibbonPlugin_1.default;
var ribbonButtonStrings_1 = require("./strings/ribbonButtonStrings");
exports.ribbonButtonStrings = ribbonButtonStrings_1.ribbonButtonStrings;
//# sourceMappingURL=index.js.map